// extracted by mini-css-extract-plugin
export default {"cls1":"PostImage-cls1_UEa","cls2":"PostImage-cls2__Q_ PostImage-cls1_UEa","border":"PostImage-border_UHp"};